import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-visitor-request',
  templateUrl: './public-visitor-request.component.html',
  styleUrls: ['./public-visitor-request.component.css']
})
export class PublicVisitorRequestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
